<template>
    <div>
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'PadmaErpSlot',

    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
};
</script>

<style lang="scss" scoped>

</style>